<template>
    <div>
        <shared-event-table v-if="getUpdateSharedEvent == null" :hardware-id="hardwareId"></shared-event-table>

        <update-shared-event></update-shared-event>
    </div>
</template>

<script>
import SharedEventTable from '@/views/Tracking/components/Aside/JourneyEvents/SharedEventTable'
import { mapGetters } from 'vuex'
import UpdateSharedEvent from '@/views/Tracking/components/Aside/JourneyEvents/UpdateSharedEvent'

export default {
    name: 'JourneySharedEventsList',
    components: { UpdateSharedEvent, SharedEventTable },
    props: {
        hardwareId: {
            type: String,
            required: true
        }
    },
    computed: {
        ...mapGetters({
            getUpdateSharedEvent: 'trackingModule/getUpdateSharedEvent'
        })
    },
    methods: {
        updateSharedEvent () {

        }
    }
}
</script>

<style scoped>

</style>
